import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { getHandleAnchorBeamGap } from "app/providers/handlePolicy";
import {
  shouldShowUHandleLengthWarning,
  uHandleLengthWarningNotification,
} from "app/providers/handleRepairNotifications";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { OptionTemplate } from "shared/api/middleware-api-client";
import { useAnalytics } from "app/hooks/shared/analytics/useAnalytics";

const selfAssemblyUHandleDisableCodes = [
  "verticalhandle",
  "verticalhandlehout",
];

export function useHandleHelper() {
  const {
    doorOptions,
    doorOptionsLoadError,
    doorOptionsLoading,
    updateHandle,
    selfAssembleDoorData,
    getConfigurationProduct,
    layout,
    selectedDoor,
    eigenwijs,
  } = useConfigurationOptionsContext();
  const { onConfig } = useAnalytics();

  const [searchParams] = useSearchParams();

  const isFrameWood = selfAssembleDoorData.measurements.frameType === "wood";
  const isFrameSteel = selfAssembleDoorData.measurements.frameType === "steel";
  const anchorBeamGap = getHandleAnchorBeamGap(eigenwijs?.beams);

  const onUpdateHandle = (handle: OptionTemplate) => {
    updateHandle(handle);

    if (
      shouldShowUHandleLengthWarning({
        anchorBeamGap,
        handleCode: handle.code,
        layoutCode: layout?.code,
      })
    ) {
      toast.info(uHandleLengthWarningNotification.message, {
        toastId: uHandleLengthWarningNotification.toastId,
      });
    }

    const product = getConfigurationProduct();
    if (product)
      onConfig({
        ...product,
        doorHandle: {
          id: handle.id,
          name: handle.name,
          code: handle.code,
          description: handle.description,
          imageId: handle.imageId,
        },
      });
  };
  return {
    doorOptionsLoading,
    doorOptionsLoadError,
    doorOptions,
    isFrameSteel,
    isFrameWood,
    selfAssembleDoorData,
    onUpdateHandle,
    searchParams,
    layout,
    selectedDoor,
    anchorBeamGap,
    selfAssemblyUHandleDisableCodes,
  };
}
